import styled from 'styled-components'

export const PostTitle = styled.h1`
  @media only screen and (max-width: 768px) {
    font-size: 30px;
  }
`